import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getSystemSettings } from '@/api/system'
import { useLayoutStore } from '@/stores/layout'
import { patchSystemConfig } from '@/utils/systemConfig'

export const useSystemStore = defineStore('system', () => {
  const loadingSystemSettings = ref(false)
  const loaded = ref(false)
  const fileDomain = ref('')
  const backUpFileDomain = ref('')
  const fileDirectory = ref([])
  const isEnableSignalrNotice = ref(false)
  const signalrNoticeHubUrl = ref('')
  const nasFileHost = ref('')
  const appId = ref('')
  const appSecret = ref('')
  const authorityUrl = ref('')

  async function initSystemSetting() {
    if (loaded.value || loadingSystemSettings.value) return
    loadingSystemSettings.value = true
    try {
      const res = await getSystemSettings()
      const data = res.data || {}
      authorityUrl.value = data.AuthorityUrl || ''
      appId.value = data.AppSetting?.AppId || ''
      appSecret.value = data.AppSetting?.AppSecret || ''
      nasFileHost.value = data.NasFileHost || ''
      fileDomain.value = data.FileDomain || ''
      backUpFileDomain.value = data.BackUpFileDomain || ''
      fileDirectory.value = data.FileDirectory || []
      isEnableSignalrNotice.value = !!data.IsEnableSignalrNotice
      signalrNoticeHubUrl.value = data.SignalrNoticeHubUrl || ''
      patchSystemConfig({
        appId: appId.value,
        appSecret: appSecret.value,
        nasFileHost: nasFileHost.value,
        authorityUrl: authorityUrl.value
      })
      useLayoutStore().setMenu(data.Hosts)
      loaded.value = true
    } catch (err) {
      console.error('Fail to download system settings, please contact Administrator.', err)
    } finally {
      loadingSystemSettings.value = false
    }
  }

  return {
    loadingSystemSettings,
    loaded,
    fileDomain,
    backUpFileDomain,
    fileDirectory,
    isEnableSignalrNotice,
    signalrNoticeHubUrl,
    nasFileHost,
    appId,
    appSecret,
    authorityUrl,
    initSystemSetting
  }
})
